export const navigation = [
  {
    text: 'ayuda',
    path: '/inicio',
    icon: 'tips'
  },
  {
    text: 'Certificados',
    path: '/Certificados',
    icon: 'orderedlist'
  },
  {
    text: 'Configuracion',
    path: '/Configuracion',
    icon: 'checklist'
  }
  
  

];
export const navigationCliente = [
  {
    text: 'ayuda',
    path: '/inicio',
    icon: 'tips'
  },
  {
    text: 'Certificados',
    path: '/Certificados',
    icon: 'orderedlist'
  },
  
  

];
